export const isServerReq = req => !req?.url?.startsWith('/_next')
